// removed by extract-text-webpack-plugin
module.exports = {"header":"header__header__3OCoR","logo":"header__logo__DccZB"};


//////////////////
// WEBPACK FOOTER
// ./src/header/header.scss
// module id = 127
// module chunks = 0